<template>
  <div
    :class="`seat-summary-container seat-summary-container--${
      itineraries_count > 2 ? 'column' : 'row'
    } content-panel`"
  >
    <div
      v-for="(itinerary, i) in itineraries"
      :key="'itinerary-' + i"
      class="flex-grow d-lg-flex d-xl-flex"
    >
      <div
        v-if="i > 0"
        class="h-100 d-none d-xl-block d-lg-block"
        :style="{
          'border-left': '1px solid #EAEBED',
          'min-width': '1px',
          'max-width': '1px',
          'margin-left': '15px',
          'margin-right': '15px',
        }"
      >
        <!-- empty -->
      </div>
      <div class="flex-grow">
        <div
          class="w-100 d-block d-xl-none d-lg-none mt-3 pb-3"
          :style="{ 'border-top': String(i) + 'px solid #EAEBED' }"
        >
          <!-- empty -->
        </div>
        <h5
          v-if="!showSelectedOnly"
          class="semibold px-2 font-size-20px"
          v-html="get_title_text(itinerary, i, itineraries_count)"
        ></h5>
        <div class="d-flex flex-column px-2" style="gap: 20px">
          <div
            v-for="segment in itinerary.segments"
            class="seat-summary"
            :key="segment.id"
          >
            <div v-if="!showSelectedOnly">
              <div class="overflow-hidden truncate-text-overflow">
                <span class="semibold mr-2">{{ segment.departure.iataCode }}</span>
                <span class="text-nowrap">{{ segment.departure.airportName }}</span>
              </div>
              <div class="overflow-hidden truncate-text-overflow">
                <span class="semibold mr-2">{{ segment.arrival.iataCode }}</span>
                <span class="text-nowrap">{{ segment.arrival.airportName }}</span>
              </div>
            </div>
            <div
              class="segment-seat-summary"
              v-if="!showSelectedOnly || segmentHasSeats(segment.id)"
            >
              <div class="semibold">{{ formatSegmentLabel(segment) }}</div>
              <summary-passenger-row
                v-for="passenger in passengers.filter(
                  (passenger) =>
                    !showSelectedOnly || getSeat(segment.id, passenger.id),
                )"
                :key="passenger.id"
                :passenger="passenger"
                :seat="getSeat(segment.id, passenger.id)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatPassengerName,
  formatSegmentLabel,
} from "@liveflight/utilities/mixins";
import { reverse_date } from "@/utilities/commons";
import {
  are_passengers_seated_on_segment,
  get_passenger_seat,
} from "@liveflight/utilities/seat-map";
import SummaryPassengerRow from "@liveflight/components/blocks/seat-map/summary/summary-passenger-row.vue";

export default {
  name: "seat-summary",
  components: {
    "summary-passenger-row": SummaryPassengerRow,
  },
  props: {
    showSelectedOnly: {
      type: Boolean,
      default: false,
    },
    itineraries: Array,
    passengers: Array,
    selections: Object,
  },
  data() {
    return {
      formatPassengerName: formatPassengerName,
      formatSegmentLabel: formatSegmentLabel,
      reverseDate: reverse_date,
      filteredPassengers: this.passengers,
    };
  },
  computed: {
    itineraries_count() {
      return this.itineraries.length;
    },
  },
  methods: {
    segmentHasSeats(segmentId) {
      return are_passengers_seated_on_segment(this.selections, segmentId);
    },
    getSeat(segmentId, passengerId) {
      return get_passenger_seat(this.selections, segmentId, passengerId);
    },
    getFlightTime(itinerary, type, includeTime = false) {
      if (!itinerary.segments.length) {
        return "TBA";
      }
      const segmentIndex =
        type === "arrival" ? itinerary.segments.length - 1 : 0;
      const { arrival, departure } = itinerary.segments[segmentIndex];
      const rawTime = type === "departure" ? departure.at : arrival.at;
      if (!rawTime) {
        return "TBA";
      }
      const timeParts = rawTime.split("T");
      if (!timeParts.length) {
        return rawTime;
      }
      return (
        this.reverseDate(timeParts[0]) +
        (includeTime && timeParts.length > 1 ? timeParts[1] : "")
      );
    },
    get_title_text(itinerary, itinerary_index, itineraries_count) {
      let itinerary_name = `Tratta ${itinerary_index + 1}`;
      let flight_time = this.getFlightTime(itinerary, "departure");
      if (itineraries_count <= 2) {
        itinerary_name = itinerary_index === 0 ? "Andata" : "Ritorno";
        flight_time =
          itinerary_index === 0
            ? flight_time
            : this.getFlightTime(itinerary, "arrival");
      }
      return `${itinerary_name} &middot; ${flight_time}`;
    },
  },
};
</script>

<style lang="scss">
.seat-summary-container {
  display: flex;
  flex-direction: column;
  gap: $grid-gutter-width;

  padding-bottom: $grid-gutter-width / 4;

  &.content-panel {
    padding-left: 0;
    padding-right: 0;
  }

  @include media-breakpoint-up(lg) {
    &--row {
      flex-direction: row;
      gap: 0;
    }
  }
}

.seat-summary {
  display: flex;
  flex-direction: column;
  gap: 20px;
  &-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.segment-seat-summary {
  border-radius: 10px;
  border: 1px solid $light-gray;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
